<template>
  <x-page title="加油券兑换" :loading="loading">
    <template v-if="!loading">
      <div :class="_.main">
        <div :class="_.quan">
          <div :class="_.title">价值100元加油券</div>
          <div :class="_.subTitle">省内中石油自营加油站均可使用</div>
          <img src="./images/quan.png" alt="" />
          <div v-if="!onlyShowDetail" :class="_.btn" @click="goExchange">
            立即兑换
          </div>
        </div>
        <div :class="_.rule">
          <img :class="_.title" src="./images/title.png" alt="" />

          <div :class="_.con">
            <div :class="_.sec">
              1.中石油加油券自兑换成功后发放5张20元中石油加油券，单次加油满200元可用1张。自购买日起60天内有效。本油券须在有效期内使用，自兑换日起开始计算，过期无效。
            </div>
            <div :class="_.sec">
              2.使用方式一:在“我的加油券包”内查询加油券，出示加油券核销码给加油站工作人员扫码核销后，支付剩余金额即可。
            </div>
            <div :class="_.sec">
              3.使用方式二:在中石油“中油好客e站”app或小程序“我的电子券”中查询加油券，出示加油券核销码给加油站工作人员扫码核销后，支付剩余金额即可。
            </div>
            <div :class="_.sec">
              4.本券仅限在贵州省内中国石油自营加油站内加油使用，可在加油券码详情页查询可用加油站。
            </div>
          </div>
        </div>
      </div>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiOrderExchangeGoodsExchangeGoodsPreOrder } from '@/api'
  import { redirectTo } from '@/router'
  import { Toast } from 'vant'
  import { Track } from '@/utils/Track'
  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '加油券兑换',
      })),
    ],
    data() {
      return {
        loading: false,
        onlyShowDetail: this.$route.query.onlyShowDetail,
      }
    },

    methods: {
      async goExchange() {
        Toast.loading({
          message: '提交中',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
        })
        await apiOrderExchangeGoodsExchangeGoodsPreOrder({
          ...this.$route.query,
        })

        Toast.clear()
        Toast('兑换成功，请去天天消费券券包查看')
        redirectTo('OrderExchangeResult', {
          sourceType: 1001,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .main {
    margin: 12px;
    background: #ffffff;
    border-radius: 8px;
    .quan {
      padding: 19px 12px 24px;
      display: flex;
      align-items: center;
      flex-direction: column;

      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
        text-align: center;
        font-style: normal;
      }
      .subTitle {
        margin-top: 8px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        text-align: center;
        font-style: normal;
      }
      img {
        margin-top: 14px;
        width: 327px;
        height: 82px;
        object-fit: cover;
      }
      .btn {
        margin-top: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        margin-top: 14px;
        width: 197px;
        height: 40px;
        text-align: center;
        background: conic-gradient(
          from 45deg at 0% 0%,
          #ff7a39 0%,
          #ff2727 100%
        );
        border-radius: 22px;
      }
    }
    .rule {
      border-top: 1px solid #e0e0e0;
      margin: 0 12px 0;
      padding-top: 23px;

      .title {
        display: block;
        width: 202px;
        height: 18px;
        margin: 0 auto 14px;
      }
      .con {
        margin-top: 14px;
        padding-bottom: 10px;
        .sec {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #666666;
          line-height: 18px;
          text-align: justify;
          font-style: normal;
          margin-bottom: 20px;
        }
      }
    }
  }
</style>
